/**
 * @generated SignedSource<<4fed8d62c3f96e10da74b993fe471e95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedRecentlyFavoritedCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_user">;
  readonly " $fragmentType": "PdpSharedRecentlyFavoritedCarousel_user";
};
export type PdpSharedRecentlyFavoritedCarousel_user$key = {
  readonly " $data"?: PdpSharedRecentlyFavoritedCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRecentlyFavoritedCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedRecentlyFavoritedCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedProductTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f3c65b52efb11d22045a7efd6050362f";

export default node;
